module.exports = __webpack_public_path__ + "img/ai.96b251dc.png";